import { Component, Ref, Prop, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class LoadMore extends ThemeComponent {
    @Prop iterate !: number;
    @Ref items !: HTMLElement[];
    @Ref trigger !: HTMLButtonElement;

    private currentlyShowing = ~~this.iterate;

    init() {
        this.updateReveal();
        this.$listen(this.trigger, 'click', () => {
            this.updateReveal();
        });
    }

    revealNext() {
        for (let i = 0; i < this.currentlyShowing; i++) {
            if (this.items[i]) {
                this.items[i].classList.add('reveal');
            }
        }
    }

    updateReveal() {
        this.currentlyShowing = ~~this.currentlyShowing + ~~this.iterate;
        this.revealNext();
        this.hideShowBtn();
    }

    hideShowBtn() {
        const total = this.trigger.dataset.total;
        if (!total) { return; }

        if (this.currentlyShowing < this.items.length) {
            this.trigger.classList.remove('hidden');
        } else {
            this.trigger.classList.add('hidden');
        }
    }
}
